export function isRedirectCandidate(pathname: string) {
    // list of eligible pathname segments to be included in A/B test consideration logic
    const eligiblePathnameSegments = ['enroll/online'];

    // find the answer
    let answer = false;
    if (eligiblePathnameSegments.some((path) => pathname.includes(path))) {
        answer = true;
    }

    return answer;
}
